import { css } from 'lit';

export const registerViewStyles = css`

  :host {
    background: linear-gradient(0deg, var(--gray-1) 0%, var(--gray-1) 70%, var(--yellow-2) 100%);

    --q1-view-width: var(--q1-content-width-narrow);
  }

  view-content {
    padding-top: 4rem;
  }

  .form-footer {
    margin: 2.5rem 0;
    font-style: italic;
  }

  header-bar {
    --header-bar-padding-trim: 6rem;
    --header-icon-color: var(--yellow-5);
    --header-icon-opacity: 0.2;
  }
  @media (min-width: 650px) {
    header-bar {
      --header-icon-opacity: 0.4;
    }
  }

`;
